import type { TBaseResponse } from "@/models/common.model"
import type { Medal } from "@/models/medals.model"
import type { HttpClient } from "@/services/http-common"
import { MedalsMapper } from "@/mappers/medals.mapper"
import ApiServiceFactory from "@/services/api-service-factory"
import { ApiError } from "@/services/http-common"
/**
 * Service for Badminton API
 */
export class MedalsService {
  private httpClient: HttpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  /**
   * Fetch foul categories from the API
   */
  async getAllMedals(): Promise<Medal[]> {
    try {
      const response = await this.httpClient.get<TBaseResponse<Medal[]>>("/medal/get-all")
      return MedalsMapper.toDto(response.value as any[])
    }
    catch (error) {
      console.error("Error fetching foul categories:", error)
      // Si el error es 404, devolvemos un array vacío
      if (error instanceof ApiError && error.status === 404) {
        console.info("No medals found, returning empty array")
        return []
      }
      // Para cualquier otro tipo de error, lo lanzamos
      throw error
    }
  }

}

export const medalsService = ApiServiceFactory.createService(MedalsService, "medal")

export default MedalsService
